module.exports = __webpack_public_path__ + "img/paypal.f266b28b.svg";